import DeviceData from './DeviceData';
import DeviceItem from './DeviceItem';

function CompressorDevice(props) {
	return <DeviceItem {...props} data={DeviceData.COMPRESSOR} />;
}

export default CompressorDevice;
